import { render, staticRenderFns } from "./BossWatchReport.vue?vue&type=template&id=4de96efc&scoped=true"
import script from "./BossWatchReport.vue?vue&type=script&lang=js"
export * from "./BossWatchReport.vue?vue&type=script&lang=js"
import style0 from "./BossWatchReport.vue?vue&type=style&index=0&id=4de96efc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de96efc",
  null
  
)

export default component.exports